<template>
    <div id="error-page">
        <div class="loghi-container">
            <img :alt="$t('error-page.logo')" id="logo" src="./../assets/logo.png">
        </div>

        <img :alt="$t('error-page.page-not-found')" id="page_not_found" src="./../assets/404.png">
    </div>
</template>

<script>
    export default {
        name: 'ErrorPage'
    }
</script>

<style>
    #error-page {
        width: 100%;
        height: 100vh;
        padding: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-color: #e9ecef;
    }
    #error-page .loghi-container {
        display: flex;
        position: fixed;   
        top: 60px;     
        justify-content: center;
        width: calc(100% - 40px);
    }
    #error-page .loghi-container #logo {
        height: 90px
    }
    img#page_not_found {
        width: 60%;
    }
    @media screen and (max-width: 550px) {
        #error-page .loghi-container #logo {
            width: 50%;
            height: unset;
            max-width: 250px;
            margin-top: 10px;
        }
    }
    @media screen and (max-width: 400px) {
        img#page_not_found {
            width: 85%;
        }
    }
</style>